<script>
import { Bar } from 'vue-chartjs';

export default {
  name: "ConsolidatedConsumeChart",
  extends: Bar,
  props: {
    chartLabels: {
      type: Array,
      required: true
    },
    chartDataValues: {
      type: Array,
      required: true
    },
    estimatedFlags: {
      type: Array,
      default: () => []
    },
    formatDateRange: {
      type: String,
      required: true
    },
    componentKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    const estimatedFlags = this.estimatedFlags || [];
    const hasEstimated = estimatedFlags.length === this.chartDataValues.length;
    const barGreen = 'rgba(137, 194, 91, 1)';
    const estimatedGreen = 'rgba(91, 138, 52, 0.9)';
    const formatDateRange = this.formatDateRange;
    const backgroundColor = hasEstimated
      ? this.chartDataValues.map((_, i) => estimatedFlags[i] ? estimatedGreen : barGreen)
      : barGreen;
    const borderColor = hasEstimated
      ? this.chartDataValues.map((_, i) => estimatedFlags[i] ? estimatedGreen : barGreen)
      : barGreen;
    return {
      chartDataConfig: {
        labels: this.chartLabels,
        datasets: [
          {
            label: `Consumo Consolidado (kg) - ${this.formatDateRange}`,
            data: this.chartDataValues,
            backgroundColor,
            borderColor,
            borderWidth: 2,
            barPercentage: 0.75,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
            }
          }],
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'kg'
            },
            ticks: {
              callback: function(value) {
                return value + ' kg';
              }
            }
          },
          x: {
            title: {
              display: true,
              text: 'Fecha'
            }
          }
        },
        tooltips: {
          callbacks: {
            title: function(tooltipItems) {
              return tooltipItems[0].xLabel;
            },
            label: function(tooltipItem) {
              const isEstimated = estimatedFlags && estimatedFlags[tooltipItem.index];
              const base = isEstimated ? 'Consumo Consolidado Estimado: ' : 'Consumo Consolidado: ';
              return base + tooltipItem.yLabel + ' kg';
            }
          },
          backgroundColor: '#fff',
          titleFontSize: 16,
          titleFontColor: '#89c25b',
          bodyFontColor: '#000',
          bodyFontSize: 14,
          displayColors: true,
          borderColor: 'rgba(137, 194, 91, 1)',
          borderWidth: 2
        },
        legend: {
          display: true,
          labels: {
            generateLabels: function() {
              return [
                {
                  text: 'Consumo Consolidado (kg) - ' + formatDateRange,
                  fillStyle: barGreen,
                  strokeStyle: barGreen,
                  lineWidth: 2
                },
                {
                  text: 'Consumo Consolidado Estimado (kg)',
                  fillStyle: estimatedGreen,
                  strokeStyle: estimatedGreen,
                  lineWidth: 2
                }
              ];
            }
          }
        }
      }
    }
  },
  mounted() {
    this.renderChart(this.chartDataConfig, this.options);
  },
};
</script>
